








































import {Component, Mixins} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {$, PageCollection, pushByName} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import ResponsavelUsuario from '@/model/resource/ResponsavelUsuario'
import * as Helper from '@/helpers/custom.helper'
import ResponsavelUsuarioCSV from '@/model/resource/ResponsavelUsuarioCSV'
import FilterResponsavelUsuario from '@/components/filters/FilterResponsavelUsuario.vue'
import FilterToggle from '@/components/FilterToggle.vue'
import ResponsavelUsuarioRequest from '@/model/request/ResponsavelUsuarioRequest'

const metaInfo = () => ({
  title: $.t('view.manage.respUser.title'),
})

@Component({
  components: {FilterResponsavelUsuario, FilterToggle},
  metaInfo,
})
export default class ManageRespUserListView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/usuario') user!: ResponsavelUsuario

  AppConfig = AppConfig
  pushByName = pushByName
  filter = new ResponsavelUsuarioRequest()
  collection = new PageCollection(ResponsavelUsuario, this.filter, 10)

  created() {
    this.collection.endpoint = '/user/responsavel-usuario'
  }

  async downloadData() {
    await $.await.run(() => Helper.downloadXlsx(
        $.t('classes.ResponsavelUsuarioCSV.title'),
        '/user/responsavel-usuario',
        this.filter,
        ResponsavelUsuarioCSV,
        'ResponsavelUsuarioCSV',
    ), 'download')
  }
}
